const initialState = {
    init: false,
    headersSetCookie: '',
    responseCountries: [],
    statusCountries: '',
    responseCoverages: [],
    statusCovarages: '',
    responseBussinesUnit: [],
    responseSupplier: [],
    responseCategory: [],
    responseZoneList: [],
    countryId: '',
    responseOffice: [],
    infoStep: [],
    hashProduct: '',
    hashFileParticular: '',
    hashFileGeneral: '',
    responseZones: [],
    status: '',
    status_cloned: '',
    responseWs: '',
    responseProducts: [],
    view: 'create',
    responseDeleteProduct: null,
    responseRateDetail: {},
    responseOfficesRate: null,
    errorOfficesRate: false,
    image: null,
    errorProduct: false,
    errorReintegros: false,
    responseRefundData: [],
    errorDataReintegro: false,
    responsePrintRefundData: [],
    errorPrintRefundData: false,
    errorCreateRefund: false,
    finalStep: false,
    completedForm: false,
    responseCreate: null,
    responseSortedProducts: [],
    responseTipologies: [],
    errorTypologies: false,
    responseTipology: [],
    errorTypology: false,
    responseUploadRefund: {},
    responseCommentsRefund: [],
    errorCommentsRefund: false,
    errorCreateComments: false,
    responseHashExportRefunds: [],
    errorHashExportRefunds: false,
    responseCheckReportRefunds: [],
    errorCheckReportRefunds: false,
    responseDuplicateListProducts: [],
    responseFilterRatesData: [],
    responseFilterRatesError: '',
    responseFilterRatesType: '',
    responseProductCodeChange: [],
    responseProductCodeChangeError: '',
    responseReint: {},

    editProductResponseError: '',
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };

    switch (action.type) {
        case "RESPONSE_PRODUCTCODE_CHANGED":
            if (action.value !== undefined) {
                newState.responseProductCodeChange = action.value;
                newState.responseProductCodeChangeError = false;
            } else {
                newState.responseProductCodeChange = [];
                newState.responseProductCodeChangeError = true;
            }
            break;
        case "FILTER_RATES_RESPONSE":
            if (action.response !== undefined) {
                newState.responseFilterRatesData = action.response.detail;
                newState.responseFilterRatesType = action.rateType;
                newState.responseFilterRatesError = false;
            } else {
                newState.responseFilterRatesData = [];
                newState.responseFilterRatesError = true;
                newState.responseFilterRatesType = action.rateType;
            }
            break;
        case "COUNTRIES_RESPONSE":
            if (action.statusCountries !== undefined) {
                newState.statusCountries = action.statusCountries
            }
            if (action.value.detail !== undefined)
                newState.responseCountries = []
            else
                newState.responseCountries = action.value
            break;
        case "BUSSINESUNIT_RESPONSE":
            newState.responseBussinesUnit = action.value
            break;
        case "SUPPLIER_RESPONSE":
            if (action.value.detail !== undefined)
                newState.responseBussinesUnit = []
            else
                newState.responseBussinesUnit = action.value.results
            newState.responseSupplier = action.value.results

            break;
        case "CATEGORY_RESPONSE":
            if (action.value.detail !== undefined)
                newState.responseCategory = []
            else
                newState.responseCategory = action.value.results

            newState.responseCategory = action.value.results

            break;
        case "COVERAGES_RESPONSE":
            if (action.statusCovarages !== undefined) {
                newState.statusCovarages = action.statusCovarages
            }
            if (action.value.detail !== undefined)
                newState.responseCoverages = []
            else
                newState.responseCoverages = action.value
            break;
        case "ZONE_RESPONSE":

            if (action.value.detail !== undefined)
                newState.responseZones = []
            else
                newState.responseZones = action.value
            break;
        case "ZONELIST_RESPONSE":

            if (action.value.detail !== undefined)
                newState.responseZoneList = []
            else
                newState.responseZoneList = action.value
            break;
        case "ZONES_RESPONSE":
            if (action.value.detail !== undefined)
                newState.responseZones = []
            else

                newState.responseZones = action.value.results
            break;
        case "OFFICES_RESPONSE":
            if (action.value.detail !== undefined)
                newState.responseOffice = []
            else
                newState.responseOffice = action.value
            break;
        case "INFO_STEP":
            newState.infoStep = [...newState.infoStep, { "step": action.step, "info": action.infoStep }];
            break;
        case "INFO_STEP_REFUND":
            if (action.step === 2 && action.infoStep.refund_payment && action.infoStep.refund_payment.status === true && action.createRefund === true) {
                newState.infoStep = [...newState.infoStep, { "step": action.step, "info": action.infoStep }];
                newState.finalStep = true;
            } else {
                newState.infoStep = [...newState.infoStep, { "step": action.step, "info": action.infoStep }];
                newState.finalStep = false;
            }
            break;
        case "REINTEGROS_LIST_RESPONSE":
            newState.responseReintegrosList = action.value
            if ((action.value.detail !== undefined) || (action.value.status === 404)) {
                newState.errorReintegros = true;
            } else {
                newState.errorReintegros = false;
            }
            break;
        case 'HASH_EXPORT_REFUNDS_RESPONSE':
            newState.responseHashExportRefunds = action.value;
            if (action.value.detail !== undefined) {
                newState.errorHashExportRefunds = true;
            } else {
                newState.errorHashExportRefunds = false;
            }
            break;
        case 'REPORT_EXPORT_REFUNDS_RESPONSE':
            newState.responseCheckReportRefunds = action.value;
            if (action.value.detail !== undefined) {
                newState.errorCheckReportRefunds = true;
            } else {
                newState.errorCheckReportRefunds = false;
            }
            break;
        case "REINTEGRO_RESPONSE":
            newState.responseReint = action.value;
            if ((action.value.detail !== undefined) || (action.value.status === 404)) {
                newState.errorReintegros = true;
            } else {
                newState.errorReintegros = false;
            }
            break;
        case "UPLOAD_IMAGE_REFUND_RESPONSE":
            newState.responseUploadRefund = action.value
            break;
        case 'PRINT_REFUND_RESPONSE':
            if (action.value.status !== undefined) {

                if (action.value.status === 'ok') {
                    newState.responsePrintRefundData = action.value;
                    newState.errorPrintRefundData = false;
                } else if (action.value.status === 'error') {
                    newState.responsePrintRefundData = action.value;
                    newState.errorPrintRefundData = true;
                }
            } else {

                newState.responsePrintRefundData = [];
                newState.errorPrintRefundData = true;
            }
            break;
        case 'REINTEGRO_CREATE_RESPONSE':
            if (action !== undefined) {
                newState.completedForm = true;
                if (action.value.status !== undefined && action.value.status === 'Error') {
                    newState.errorCreateRefund = true;
                    newState.responseCreate = null;
                } else {
                    newState.errorCreateRefund = false;
                    newState.responseCreate = action.value;
                }
            }
            break;
        case "REFUND_DATA_RESPONSE":
            if (action.value.detail !== undefined) {
                newState.responseRefundData = [];
            } else {
                newState.responseRefundData = action.value
            }
            if ((action.value.detail !== undefined) || (action.value.status === 404)) {
                newState.errorDataReintegro = true;
            } else {
                newState.errorDataReintegro = false;
            }
            break;
        case "REFUND_COMMENTS_RESPONSE":
            newState.responseCommentsRefund = action.value;
            if (action.value.status !== undefined) {
                if (action.value.status === 'ok') {
                    newState.errorCommentsRefund = false;
                } else {
                    newState.errorCommentsRefund = true;
                }
            } else {
                newState.errorCommentsRefund = true;
            }
            break;
        case "CREATE_COMMENTS_REFUND_RESPONSE":
            newState.responseCommentsRefund = action.value;
            if (action.value.status !== undefined) {
                if (action.value.status === 'ok') {
                    newState.errorCreateComments = false;
                } else {
                    newState.errorCreateComments = true;
                }
            } else {
                newState.errorCreateComments = true;
            }
            break;
        case "PRODUCT_RESPONSE":
            if (action.response.hash !== undefined) {
                newState.status = "SUCCESS";
                newState.hashProduct = action.response.hash;
            } else {
                newState.status = "ERROR";
                newState.responseWs = action.response;
            }
            break;
        case "FILE_RESPONSE":

            newState.status = '';
            if (action.tipoTarifa === 'general')
                newState.hashFileGeneral = action.value.hash;
            else
                newState.hashFileParticular = action.value.hash;

            break;
        case "PRODUCT_RESPONSE_FINAL":
            if (action.productResponse.status === "OK") {
                newState.status = "SUCCESS";
                newState.status_cloned = "SUCCESS_CLONED";
            } else {
                newState.status = "ERROR";
                newState.status_cloned = "ERROR_CLONED";
                newState.responseWs = action.createProduct;
            }

            break;
        case "PRODUCTS_RESPONSE":
            newState.responseProducts = action.response
            newState.view = action.view

            if (action.response.detail !== undefined) newState.errorProduct = true;
            else newState.errorProduct = false

            if (action.responseDelete !== undefined) {
                if (action.responseDelete.status === 204) {
                    newState.responseDeleteProduct = { "status": true, "id": action.id }
                } else
                    newState.responseDeleteProduct = { "status": false, "id": action.id };
            }
            break;
        case "PRODUCTS_DUPLICATE_LIST_RESPONSE":
            if (action.response !== undefined) {
                newState.responseDuplicateListProducts = action.response
            }
            break;
        case "PRODUCTS_RESPONSE_REDUCIDA":
            newState.responseProducts = action.response
            newState.view = action.view

            if (action.response.detail !== undefined) newState.errorProduct = true;
            else newState.errorProduct = false

            if (action.responseDelete !== undefined) {
                if (action.responseDelete.status === 204) {
                    newState.responseDeleteProduct = { "status": true, "id": action.id }
                } else
                    newState.responseDeleteProduct = { "status": false, "id": action.id };
            }
            break;
        case "PRODUCT_RESPONSE_EDIT":
            if (action.response.status === "OK") {
                newState.status = "SUCCESS";
                newState.editProductResponseError = false;
            } else {
                newState.editProductResponseError = true;
                if (action.response.detail) {
                    newState.status = "ERROR";
                    newState.responseWs = action.response;
                } else {
                    newState.status = "ERROR";
                    newState.responseWs = '';
                }
            }

            break;
        case "PRODUCT_RESPONSE_REMOVE":
            break;
        case "SORTED_PRODUCTS_RESPONSE":
            newState.responseSortedProducts = action.response
            break;
        case "RATE_DETAIL_RESPONSE":

            newState.responseRateDetail = (action.value.detail !== undefined) ? {} : action.value;
            newState.status = '';
            break;
        case "GET_RATE_BY_ID":
            newState.responseRateDetail = (action.value.detail !== undefined) ? {} : action.value;
            newState.status = '';
            break;

        case "EDIT_OFFICES_RATE_RESPONSE":
            newState.responseOfficesRate = action.value;
            if (action.value.detail !== undefined) {
                newState.errorOfficesRate = true;
            }
            break;

        case "IMAGE_RESPONSE":
            newState.image = (action.value.id !== undefined) ? action.value : false;
            break;

        case "TYPOLOGIES_RESPONSE":
            newState.responseTipologies = action.response
            if (action.response.detail !== undefined) newState.errorTypologies = true;
            else newState.errorTypologies = false

            break;

        case "TYPOLOGY_RESPONSE":
            newState.responseTipology = action.value;
            break;

        default:
            return newState;

    }

    return newState;
};

export default reducer;